module.exports = __webpack_public_path__ + "static/media/profile-onboarding.4c043893.jpeg";